'use client';

import { type ReactNode, createContext, useContext } from 'react';

import {
  type SectionVisibilityMap,
  createHiddenVisibility,
} from '~/lib/section-visibility';

const SectionVisibilityContext = createContext<SectionVisibilityMap>(
  createHiddenVisibility(),
);

export function SectionVisibilityProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: SectionVisibilityMap;
}) {
  return (
    <SectionVisibilityContext.Provider value={value}>
      {children}
    </SectionVisibilityContext.Provider>
  );
}

/**
 * Access page-section visibility toggles.
 * Falls back to all-hidden when used outside of a provider.
 */
export function useSectionVisibility(): SectionVisibilityMap {
  return useContext(SectionVisibilityContext);
}
